import { render, staticRenderFns } from "./InquiryNumber.vue?vue&type=template&id=cfcbb7d0&"
import script from "./InquiryNumber.vue?vue&type=script&lang=js&"
export * from "./InquiryNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports